

import React from 'react'
import ZNetwork from "./znetwork";
import ZUtil from "./zutil";
import ZLog from "./zlog";
import ZProps from "./zprops";
import AMC from "./AMC";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisV} from '@fortawesome/free-solid-svg-icons'

// https://www.taniarascia.com/add-comments-to-static-site/
export default class ZComments extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	componentDidMount() {
		const { thing_uri } = this.props;
		ZNetwork.get("comments", thing_uri, (err, comments) => {
			if (err) {
				this.setState({ error: true })
			} else {
				this.setState({ comments: comments })
			}
		});
	}
	render() {
		const { thing_uri } = this.props;
		let { error, comments } = this.state;
		return (
			<div>
				{!error && <ZCommentsArea key={comments && comments.length} comments={comments} slug={thing_uri} />}
			</div>
		)
	}
}

class ZCommentsArea extends React.Component {
	constructor(props) {
		super(props);
		this.poster = ZProps.get("user");
		this.initialState = {
			comments: this.props.comments || [],
			newComment: {
				text: '',
				id: Date.now(),
				poster_name: this.poster.name,
				poster_uri: this.poster.uri,
				poster_avatar: this.poster.avatar,
			},
			submitting: false,
			success: false,
			error: false,
		};
		this.state = this.initialState;
	}
	onStartCommenting = event => {
		this.setState({ commenting: true });
	}
	onCancelCommenting = event => {
		this.setState({ commenting: false });
	}
/*
									<div>
										<div className="ZCommentReply" onClick={this.onReply.bind(this, comment)}>Reply</div>
									</div>
	onReply = (comment, event) => {
		let comment = this.newComment();
	}
*/
	onSubmitComment = event => {
		event.preventDefault()

		// Set this so the button can't be pressed repeatedly
		this.setState({ submitting: true })

		const { newComment, comments } = this.state;

		ZNetwork.post("comment", this.props.slug, { comment: newComment }, (err) => {
			if (err) {
				this.setState({ ...this.initialState, error: true })
			} else {
			// Append comment and reset newComment
				this.setState({
					comments: [newComment, ...comments],
					newComment: {
						text: '',
						id: Date.now(),
						poster_name: this.poster.name,
						poster_uri: this.poster.uri,
						poster_avatar: this.poster.avatar,
					},
					success: true,
					error: false,
				});
			}
		});
	}
	handleChange = event => {
		const { newComment } = this.state;
		const { name, value } = event.target;

		this.setState({
			newComment: { ...newComment, [name]: value, date: Date.now() }
		});
	}
	showMenubuttons = (comment, event) => {
		event.preventDefault();
		event.stopPropagation();
		this.setState({ menu: comment.id });
	}
	hideMenu = () => {
		this.setState({ menu: null });
	}
	reportComment = (comment, event) => {
		AMC.report(this.props.slug, { name: "comment", body: comment });
		//comment.reported = (comment.reported || 0) + 1;
		//ZNetwork.post("editcomment", this.props.slug, { comment: comment }, (err) => {
			this.setState({ success: true });
		//});
	}
	render() {
		const { submitting, success, error, comments, newComment: { text }, commenting, menu } = this.state

		const user= ZProps.get("user");
		const ownerthumb = AMC.getUserThumbElement(user);
		const avatar = <span className={"ZCommentsFormAvatar" + (user.avatar ? "" : " ZCommentsFormAvatarDefault")}>{ownerthumb}</span>
//  onClick={this.onStartCommenting.bind(this)}>
//					{num_comments > 0 ? <span className="ZooPageProfileShowCommentsButton" onClick={this.showComments.bind(this)}>Show Comments</span> : '' }
		const commentForm = () => (
			<div className="ZCommentsForm ClearFix">
				{avatar}
				<div className="ZCommentingArea">
				<textarea
					className={commenting ? "ZCommentingTextField" : "ZCommentingPrompt"}
					rows="1"
					cols="5"
					name="text"
					id="text"
					value={text}
					onChange={this.handleChange}
					placeholder={"Add a public comment as " + user.name}
					onFocus={this.onStartCommenting.bind(this)}
					required
				/>
				{ commenting ? 
					<span>
						<button className="ZCommentsCommentButton"  type="submit" disabled={!text || text.length < 2 || submitting} onClick={this.onSubmitComment.bind(this)}>
							Comment
						</button>
						<button className="ZCommentsCancelButton" type="cancel" disabled={submitting} onClick={this.onCancelCommenting.bind(this)}>
							Cancel
						</button>
					</span>
				: '' }
				</div>
			</div>
		);
		const showError = () =>
			error && (
				<div className="error">
					<p>Comment failed to submit.</p>
				</div>
			)

		const showSuccess = () =>
			success && (
				<div className="success">
					<p>Thank you for commenting!</p>
				</div>
			)

		const showAvatar = (comment) => {
			return AMC.getUserThumbElement( { uri: comment.poster_uri, avatar: comment.poster_avatar } );
		}
		return (
			<section className="ZComments" onClick={this.hideMenu.bind(this)}>
				<h4>Comments - {comments.length} </h4>
				{success || error ? showError() || showSuccess() : commentForm()}
				<div className="ZCommentsList">
				{comments.length > 0 &&
					comments
						.filter(comment => !comment.parent_comment_id)
						.map((comment, i) => {
							ZLog.warn("comment with no parent id" +comment.text);
							let children = comments.filter(c => comment.id === c.parent_comment_id)
							return (
								<div className="ZComment" key={i}>
									<div className="ZCommentAvatar">{ showAvatar(comment) } </div>
									<header>
										<a href={"/zoo/" + comment.poster_uri}>{comment.poster_name}</a>
										<div className="ZCommentDate">{ZUtil.timeagowords(comment.date)}</div>
										{menu === comment.id ? 
										<div className="ZCommentMenu" onClick={this.reportComment.bind(this, comment)}>report</div> 
										: 
										<div className="ZCommentMenuButton" onClick={this.showMenubuttons.bind(this, comment)}><FontAwesomeIcon icon={faEllipsisV} />}</div>
										}
									</header>
									<p>{comment.text}</p>
									{ children.length > 0 ?
										children.map( child => {
											return (
												<div className="ZCommentDateReply">
													<header>
														<h2>{child.poster}</h2>
														<div className="ZCommentDate">{ZUtil.timeagowords(child.date)}</div>
													</header>
													<p>{child.text}</p>
												</div>
											)
										})
									: '' }
								</div>
							)
						})}
				</div>
			</section>
		)
	}
}




// WEBPACK FOOTER //
// ./src/zcomments.js